import { render } from "./Home.vue?vue&type=template&id=4828e7ac&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4828e7ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4828e7ac"

export default script